// IMPORTANT : the content of this file is not imported when using the transformer

export interface FunctionParameter {
    name: string;
    /** typescript 'real' type */
    type: string | undefined;
    /** type written in file (if several types are declared, contains the types sorted by name and separated with a comma ex: 'NUMBER, STRING') */
    declaredType?: string;
    /** true if parameter is optional */
    isOptional?: boolean;
    /** true if parameter is ...rest */
    isRest?: boolean;
}
export interface DecoratorInfos {
    name: string;
    /**
     * parameters are JSON.parsed, if parameter is not a valid JSON (ie without quotes around keys) the string if left as is
     */
    parameters?: unknown[];
}

export interface PropertyInfos {
    /** typescript 'real' type */
    type: string;
    /** type written in file (if several types are declared, contains the types sorted by name and separated with a comma ex: 'NUMBER, STRING') */
    declaredType?: string;
    /** set if property is a function */
    function?: {
        /** mandatory parameters count */
        mandatoryParameters?: number,
        /** set if function have parameters */
        parameters?: FunctionParameter[],
        /** typescript 'real' return type */
        returnType: string,
        /** type written in file (if several types are declared, contains the types sorted by name and separated with a comma ex: 'NUMBER, STRING') */
        returnDeclaredType?: string
    };
    /** property decorators */
    decorators?: DecoratorInfos[];
    /** true if property is optional */
    isOptional?: boolean;
}


// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface TypeInfos<T = unknown> {
    /** type name */
    type?: string;
    /** propertyName => PropertyInfos */
    properties?: { [name: string]: PropertyInfos };
}

/**
 * Throws an error explaining how to use the transformer
 */
export function noTransformerError(functionName?: string): void {
    throw new Error(`${functionName ? functionName + ": " : ""}You must use the provided typescript transformer to use @cervval.js/ts-reflect package.

    - Check ts-patch was installed (done by builder post-intall script when you run 'pnpm i')
    - Check your tsconfig file : use @cervval.js/builder/typescript/tsconfig-base.json or configure you tsconfig.json as below
    "compilerOptions": {
        "plugins": [{"transform": "@cervval.js/builder/typescript/ts-reflect-transformer"}]
    }
    
    - If using tts-mocha from a location that does not have a tsconfig.json file, you can add --register-reflect as first parameter of tts-mocha
    tts-mocha --register-reflect **/*.spec.ts
    `);
}

/**
 * Get keys of interface or type
 */
export function keys<T>(): Array<keyof T> {
    // This function is not supposed to be called since the transformer replaces the call to keys by the keys array.
    noTransformerError("keys");
    throw "error";
}

/**
 * Get Type informations of an interface or type
 */
export function typeInfos<T>(): TypeInfos<T> {
    // This function is not supposed to be called since the transformer replaces the call to typeInfos by a TypeInfos object.
    noTransformerError("typeInfos");
    throw "error";
}
